import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useGoBack from "hooks/useGoBack";
import useUserStore from "@store/useUserStore";
import { getMyTours } from "api/travel";
import NoData from "components/common/NoData";
import dayjs from "dayjs";
import { getKstDday } from "utils/util";
import SubHeader from "components/common/SubHeader";
import "assets/scss/pages/mybuccl.scss";

const getDday = getKstDday;

const formatDateRange = (startDate, endDate) => {
    const s = dayjs(startDate);
    const e = dayjs(endDate);
    const nights = e.diff(s, "day");
    return `${s.format("M/D")}~${e.format("M/D")} (${nights}박${nights + 1}일)`;
};

const TourHistory = () => {
    const navigate = useNavigate();
    const goBack = useGoBack();
    const userInfo = useUserStore((state) => state.userInfo);
    const [upcomingItems, setUpcomingItems] = useState([]);
    const [pastItems, setPastItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (userInfo !== null) {
            setIsLoading(true);
            getMyTours(true)
                .then((tours) => {
                    const upcoming = tours
                        .filter((t) => t.status !== "COMPLETED")
                        .sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
                    const past = tours
                        .filter((t) => t.status === "COMPLETED")
                        .sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
                    setUpcomingItems(upcoming);
                    setPastItems(past);
                })
                .catch((err) => console.error("투어 내역 로딩 오류:", err))
                .finally(() => setIsLoading(false));
        }
    }, [userInfo]);

    const renderCard = (tour, isPast) => {
        const d = dayjs(tour.start_date);
        const detail = [tour.location, formatDateRange(tour.start_date, tour.end_date)].filter(Boolean).join(" | ");

        return (
            <div
                key={tour.id}
                className={`reservation-card ${isPast ? "reservation-card--past" : ""}`}
                onClick={() => navigate(`/tour/detail/${tour.id}`)}
            >
                <div className={`reservation-date-block date-block--tour ${isPast ? "date-block--past" : ""}`}>
                    <span className="reservation-date-month">{d.format("M")}월</span>
                    <span className={`reservation-date-day ${!isPast ? "day--tour" : ""}`}>{d.format("D")}</span>
                </div>
                <div className="reservation-card-content">
                    <p className="reservation-card-title">{tour.name}</p>
                    <p className="reservation-card-detail">{detail}</p>
                </div>
                <span className={`reservation-card-dday ${isPast ? "dday--past" : "dday--tour"}`}>
                    {isPast ? "완료" : getDday(tour.start_date)}
                </span>
            </div>
        );
    };

    return (
        <div className="community-page community-list">
            {/* <div className="community-header detail-header">
                <div className="header-content">
                    <button className="back-button" onClick={() => goBack()}>
                        <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
                            <path d="M15 19l-7-7 7-7" stroke="#17191a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <h1 className="header-title">투어 내역</h1>
                </div>
            </div> */}
            <SubHeader title="투어 내역" customGoback={() => goBack()}/>
            <div className="reservation-tab">
                {isLoading ? (
                    <div style={{ textAlign: "center", padding: "60px 0", color: "#999" }}>불러오는 중...</div>
                ) : upcomingItems.length === 0 && pastItems.length === 0 ? (
                    <NoData title="✈️" desc="아직 참가한 투어가 없어요." />
                ) : (
                    <>
                        {upcomingItems.length > 0 && (
                            <div className="reservation-section">
                                <h3 className="reservation-section-title">📅 다가오는 투어</h3>
                                <div className="reservation-list">
                                    {upcomingItems.map((tour) => renderCard(tour, false))}
                                </div>
                            </div>
                        )}
                        {pastItems.length > 0 && (
                            <div className="reservation-section">
                                <h3 className="reservation-section-title">📋 지난 투어</h3>
                                <div className="reservation-list">
                                    {pastItems.map((tour) => renderCard(tour, true))}
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default TourHistory;
